import { X, DollarSign, Loader2, Unlock, AlertTriangle, Ban } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

export const PaymentModal = ({
  paymentModal, setPaymentModal,
  captureAmount, setCaptureAmount,
  cancelFeePercent, setCancelFeePercent,
  paymentLoading,
  capturePayment, cancelPayment,
}) => {
  if (!paymentModal) return null;

  return (
    <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4" onClick={() => setPaymentModal(null)}>
      <div className="bg-zinc-900 border border-zinc-700 rounded-xl p-6 w-full max-w-md" onClick={e => e.stopPropagation()}>
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-bold text-white">
            {paymentModal.type === 'capture' ? 'Capturer le paiement' : 'Annuler le paiement'}
          </h3>
          <button onClick={() => setPaymentModal(null)} className="text-zinc-400 hover:text-white"><X className="w-5 h-5" /></button>
        </div>
        {paymentModal.type === 'capture' ? (
          <div className="space-y-4">
            <p className="text-zinc-400 text-sm">Montant pre-autorise: <span className="text-amber-400 font-bold">{paymentModal.booking.amount_authorized}€</span></p>
            <div>
              <label className="text-zinc-400 text-sm block mb-1">Montant a capturer (€)</label>
              <Input type="number" step="0.01" value={captureAmount} onChange={e => setCaptureAmount(e.target.value)} className="bg-zinc-800 border-zinc-700 text-white" data-testid="capture-amount-input" />
            </div>
            <Button onClick={capturePayment} disabled={paymentLoading} className="w-full bg-emerald-600 hover:bg-emerald-700 text-white" data-testid="capture-confirm-btn">
              {paymentLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : <><DollarSign className="w-4 h-4 mr-2" /> Capturer {captureAmount}€</>}
            </Button>
          </div>
        ) : (
          <div className="space-y-4">
            <p className="text-zinc-400 text-sm">Montant pre-autorise: <span className="text-amber-400 font-bold">{paymentModal.booking.amount_authorized}€</span></p>
            <div className="space-y-2">
              <Button onClick={() => setCancelFeePercent(0)} variant={cancelFeePercent === 0 ? 'default' : 'outline'} className={`w-full ${cancelFeePercent === 0 ? 'bg-emerald-600' : 'border-zinc-700 text-zinc-300'}`}>
                <Unlock className="w-4 h-4 mr-2" /> Rembourser integralement (0%)
              </Button>
              <Button onClick={() => setCancelFeePercent(30)} variant={cancelFeePercent === 30 ? 'default' : 'outline'} className={`w-full ${cancelFeePercent === 30 ? 'bg-amber-600' : 'border-zinc-700 text-zinc-300'}`}>
                <AlertTriangle className="w-4 h-4 mr-2" /> Frais 30% ({(paymentModal.booking.amount_authorized * 0.3).toFixed(2)}€)
              </Button>
              <Button onClick={() => setCancelFeePercent(50)} variant={cancelFeePercent === 50 ? 'default' : 'outline'} className={`w-full ${cancelFeePercent === 50 ? 'bg-orange-600' : 'border-zinc-700 text-zinc-300'}`}>
                <AlertTriangle className="w-4 h-4 mr-2" /> Frais 50% ({(paymentModal.booking.amount_authorized * 0.5).toFixed(2)}€)
              </Button>
              <Button onClick={() => setCancelFeePercent(100)} variant={cancelFeePercent === 100 ? 'default' : 'outline'} className={`w-full ${cancelFeePercent === 100 ? 'bg-red-600' : 'border-zinc-700 text-zinc-300'}`}>
                <Ban className="w-4 h-4 mr-2" /> Conserver 100% ({paymentModal.booking.amount_authorized}€)
              </Button>
            </div>
            {cancelFeePercent !== null && (
              <Button onClick={cancelPayment} disabled={paymentLoading} className="w-full bg-red-600 hover:bg-red-700 text-white" data-testid="cancel-confirm-btn">
                {paymentLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Confirmer l\'annulation'}
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
